import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { createHead } from '@vueuse/head';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { 
  faSearch, 
  faPlus, 
  faTrash, 
  faPencil,
  faDownload,
  faUpload,
  faLink,
  faGrip,
  faSpinner,
  faCheck,
  faTimes,
  faExclamationTriangle,
  faInfoCircle,
  faArrowUp,
  faArrowDown,
  faArrowsUpDown,
  faBroom,
  faEnvelope,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faBars
} from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

import './style.css';
import App from './App.vue';

// Add icons to library
library.add(
  faSearch,
  faPlus,
  faTrash,
  faPencil,
  faDownload,
  faUpload,
  faLink,
  faGrip,
  faSpinner,
  faCheck,
  faTimes,
  faExclamationTriangle,
  faInfoCircle,
  faArrowUp,
  faArrowDown,
  faArrowsUpDown,
  faBroom,
  faWhatsapp,
  faEnvelope,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faBars
);

const app = createApp(App);
const head = createHead();

app.component('FontAwesomeIcon', FontAwesomeIcon);
app.use(createPinia());
app.use(head);
app.mount('#app');